/*
 * @Editor: SiYuan Wang
 * @Date: 2018-08-22 14:56:12
 * @Description: util
 */

/*
   0 正常开放，“定投、购买”两个按钮都正常显示
   1 认购时期，只显示“购买”，但是撤单不能操作，认购一般不允许撤单，赎回也不能操作
   2 停止赎回，“赎回”菜单不可操作
   3 停止申购，“定投、购买”都不可操作
   5 停止交易，“定投、购买、赎回”都不可操作
   6 基金终止，“定投、购买、赎回”都不可操作
   9 发行失败，“定投、购买、赎回”都不可操作
*/

var IS_DEV = process.env.NODE_ENV === 'development'
    || process.env.type === 'uat';
export default {
    install (Vue) {
        Vue.prototype.__C = {
            urlForJjw: IS_DEV ? 'https://uat.jinjiwo.com:25013' : 'https://www.jinjiwo.com'
            // urlForSdj: IS_DEV ? 'https://uatjinjiwo.1shitou.cn:5061' : 'https://www.10doujin.com'
        },
        Vue.prototype.post = function (url, params, opts) {
            this.ajax('post', url, params, opts);
        },
        Vue.prototype.get = function (url, params, opts) {
            this.ajax('get', url, params, opts);
        },
        Vue.prototype.ajax = function (type, url, params, opts) {
            if (!opts.notLogin) {
                if(!sessionStorage.getItem('access_token')){
                    window.location.href = '/accountcenter/login.html';
                    return false;
                }
            }
            var that = this;
            var srcUrl = (opts.url ? opts.url : window.ajaxUrl) + url;
            var async = true;
            if(opts.hasOwnProperty("async")){
                async = opts.async;
            }
            var headers = opts.isToken ? {} : {
                AccessToken: sessionStorage.getItem('access_token')
            }
            $.ajax({
                type: type,
                url: srcUrl,
                data: params,
                async: async,
                dataType: 'json',
                headers: headers,
                beforeSend: function () {
                    if (opts.isLoading) {
                        that.showLoading(opts.loadingDom);
                    }
                },
                success: function (res){
                    if (res.code === 0) {
                        if(opts.isLoading){
                            that.hideLoading(opts.loadingDom);
                        }
                        opts.success(res.content);
                    } else if (res.code === 1001) {
                        if(opts.isLoading){
                            that.hideLoading(opts.loadingDom);
                        }
                        sessionStorage.setItem('access_token', '');
                        window.location.href = '/accountcenter/login.html';
                    } else if (res.code === 1003) {
                        that.refreshToken(function () {
                            $.ajax({
                                type: type,
                                url: srcUrl,
                                data: params,
                                dataType: 'json',
                                headers: {
                                    AccessToken: sessionStorage.getItem('access_token')
                                },
                                success: function (res2) {
                                    if (res2.code === 0) {
                                        if (opts.isLoading) {
                                            that.hideLoading(opts.loadingDom);
                                        }
                                        opts.success(res2.content);
                                    }
                                }
                            })
                        }, window.oldToken);
                    }else{
                        if (opts.isLoading) {
                            that.hideLoading(opts.loadingDom);
                        }
                        if (opts.error) {
                            opts.error(res);
                        } else {
                            // alert(JSON.stringify(res))
                            return false;
                        }
                    }
                },
                error: function () {
                    if (opts.isLoading) {
                        that.hideLoading();
                    }
                    // alert(JSON.stringify(err))
                }
            });
        },
        Vue.prototype.refreshToken = function (callback, token) {
            var that = this;
            if (token === sessionStorage.getItem('access_token')) {
                $.ajax({
                    type: 'POST',
                    url: window.platformUrl + 'oauth/token',
                    async: false,
                    data: {
                        grant_type: 'refresh_token',
                        refresh_token: sessionStorage.getItem('refresh_token'),
                        client_id: 'client_fund_password',
                        client_secret: 123456
                    },
                    dataType: 'json',
                    success: function (res) {
                        if (res.code === 200) {
                            window.oldToken = sessionStorage.getItem('access_token');
                            sessionStorage.setItem("access_token", res.access_token);
                            sessionStorage.setItem("refresh_token", res.refresh_token);
                            callback();
                        } else {
                            window.oldToken = 'token';
                            that.$alert('您的登录信息已失效，请重新登录', '提示', {
                                confirmButtonText: '确定',
                                callback: function () {
                                    sessionStorage.setItem('access_token', '');
                                    window.location.href = '/accountcenter/login.html';
                                }
                            });
                        }
                    }
                });
            } else {
                callback();
            }
        },
        Vue.prototype.showLoading = function (dom) {
            var loading = document.createElement('div');
            loading.className = 'loading';
            loading.innerHTML = '<p><span></span><span></span>加载中</p>';
            if (typeof dom !== 'undefined') {
                var dom$ = $(dom);
                dom$.append(loading);
                dom$.css('position', 'relative');
                dom$.find('.loading').css('position', 'absolute');
            } else {
                $('body').append(loading);
            }
        },
        Vue.prototype.hideLoading = function (dom) {
            if (typeof dom !== 'undefined') {
                $(dom).find('.loading').remove();
            } else {
                $('.loading').remove();
            }
        },
        Vue.prototype.getQuery = function (name, Url) {
            var reg = new RegExp("(^|\\?|&)"+ name +"=([^&]*)(\\s|&|$)", "i");
            var url = Url || window.location.href;
            if (reg.test(url)) {
                return unescape(RegExp.$2.replace(/\+/g, ''));
            }
            return '';
        },
        Vue.prototype.goInfoLink = function (fundCode) {
            var self = this;
            this.get('fund/' + fundCode + '/inner/code', {}, {
                isLoading: true,
                success: function (res){
                    var url = `${self.__C.urlForJjw}/fund/detail/info/${res}.html`;
                    //var url = `${self.__C.urlForJjw}/fund.html?fundCode=${fundCode}&innerCode=${res}`;
                    $('body').append($('<a href="' + url + '" target="_blank" id="openWin"></a>'));
                    document.getElementById("openWin").click();
                    $('#openWin').remove();
                }
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/util.js